import {
  apiClient,
  type CreateTruckClassImportJobDto,
  type TruckClassImportJobExEntity
} from '@/libs/api'

export type CreateTruckClassImportJobRequest = {
  tenantKey: string
  dto: CreateTruckClassImportJobDto
}

export const createTruckClassImportJob = async ({
  tenantKey,
  dto
}: CreateTruckClassImportJobRequest): Promise<TruckClassImportJobExEntity> => {
  const { data } = await apiClient
    ._tenant(tenantKey)
    .truck_class_import_jobs.$post({
      body: dto
    })
  return data
}
